export const RefreshIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    <path
      d="M10.5629 4.87501H9.18751C8.70353 4.87501 8.31251 5.26603 8.31251 5.75001C8.31251 6.234 8.70353 6.62501 9.18751 6.62501H12.6875C13.1715 6.62501 13.5625 6.234 13.5625 5.75001V2.25001C13.5625 1.76603 13.1715 1.37501 12.6875 1.37501C12.2035 1.37501 11.8125 1.76603 11.8125 2.25001V3.65001L11.3313 3.16876C8.93868 0.776184 5.06134 0.776184 2.66876 3.16876C0.276184 5.56134 0.276184 9.43868 2.66876 11.8313C5.06134 14.2238 8.93868 14.2238 11.3313 11.8313C11.6731 11.4895 11.6731 10.9344 11.3313 10.5926C10.9895 10.2508 10.4344 10.2508 10.0926 10.5926C8.38361 12.3016 5.61368 12.3016 3.9047 10.5926C2.19572 8.88361 2.19572 6.11368 3.9047 4.4047C5.61368 2.69572 8.38361 2.69572 10.0926 4.4047L10.5629 4.87501Z"
      fill="currentColor"
    />
  </svg>
);
